import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import "./msw";

console.log(`script-frontend app version: ${import.meta.env.VITE_APP_VERSION}`);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
